<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create Vertical
            </h2>
        </template>

        <vertical-form :action="route('verticals.store')" method="POST" button="CREATE"></vertical-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import VerticalForm from './Form';

    export default {
        components: {
            AppLayout,
            VerticalForm,
        },
    }
</script>
